import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '@/store';
// import { setToken } from '@/store/slices/authSlice';
// import { ApiResponse, AuthTokens } from '@/types';
import Cookies from 'js-cookie';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  prepareHeaders: (headers, { getState }) => {
    const token = Cookies.get('authToken');
    const tempAuthToken = (getState() as RootState).auth.tempAuthToken;
    const finalToken = token || tempAuthToken;
    if (finalToken) {
      headers.set('authorization', `Bearer ${finalToken}`);
    }
    // headers.set('content-type', 'application/json');
    return headers;
  },
});

const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    console.warn('Unauthorized! Logging out user...');
    Cookies.remove('authToken');
    setTimeout(() => {
      if (window.location.pathname === '/login') return;
      window.location.href = '/login';
    }, 2000);
  }
  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  // baseQuery: baseQuery,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ['User', 'Auth', 'FeatureFlags', 'Competitions', 'Events'],
  endpoints: () => ({}),
});

// Export hooks for usage in functional components
export const {
  util: { getRunningQueriesThunk },
} = apiSlice;

export default apiSlice;